import RootStore from "SandboxViewerComponent/src/stores/RootStore";
// import WMSLayerPicker from "@giscon/widgets.wms-layer-picker";
import { createWMSSublayer } from "@giscon/utils.layer-utils";
import * as urlUtils from "@arcgis/core/core/urlUtils";
import {
  LayerControlTree,
  configToTree,
  getNodesFromIds,
  getPathToRoot,
  getNodeFromId,
  defaultNLS,
} from "@giscon/widgets.group-layer-manager";
import { useEffect, useMemo, useState } from "react";
import {
  StoreGroupLayer,
  Layer,
  TemplateInfo,
} from "@giscon/utils.layer-store";
import { StoreGroupLayerOverview } from "@giscon/widgets.layer-overview";
import { renderPreviewHTML } from "@arcgis/core/symbols/support/symbolUtils";
import { observer } from "mobx-react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Paper,
} from "@mui/material";
import { ShapefileToGeojson } from "@giscon/widgets.shapefile-to-geojson";
import proj4 from "proj4";
import { ExpandMore } from "@mui/icons-material";
import APIHelperEsri from "@giscon/utils.api-helper-esri";
import HelpLink from "./HelpLink";
import AccordionPanel from "components/AccordionPanel";
// import shp from "shpjs";

// function toBuffer (b) {
//   if (!b) {
//     throw new Error('forgot to pass buffer');
//   }
//   if (Buffer.isBuffer(b)) {
//     return b;
//   }
//   if (isArrayBuffer(b)) {
//     return Buffer.from(b);
//   }
//   if (isArrayBuffer(b.buffer)) {
//     if (b.BYTES_PER_ELEMENT === 1) {
//       return Buffer.from(b);
//     }
//     return Buffer.from(b.buffer);
//   }
// }
// const origParseShp = shp.parseShp;
// shp.parseShp = function (shp, prj) {
//   shp = toBuffer(shp);
//   if (Buffer.isBuffer(prj)) {
//     prj = prj.toString();
//   }
//   if (typeof prj === 'string') {
//     try {
//       prj = proj4(prj);
//     } catch (e) {
//       prj = false;
//     }
//   }
//   return parseShp(shp, prj);
// };
// const tmerc = proj4.Proj.projections.get("Transverse_Mercator");
// tmerc.names.push("Gauss_Kruger");
// proj4.Proj.projections.add(tmerc);

proj4.defs(
  "EPSG:2327",
  "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +a=6378140 +b=6356755.288157528 +units=m +no_defs"
);
proj4.defs(
  "EPSG:31467",
  "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +nadgrids=BETA2007.gsb +units=m +no_defs +type=crs"
);
// proj4.defs(
//   `PROJCS["DHDN_3_Degree_Gauss_Zone_3",GEOGCS["GCS_Deutsches_Hauptdreiecksnetz",DATUM["D_Deutsches_Hauptdreiecksnetz",SPHEROID["Bessel_1841",6377397.155,299.1528128]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Gauss_Kruger"],PARAMETER["False_Easting",3500000.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",9.0],PARAMETER["Scale_Factor",1.0],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0]]`,
//   proj4.defs("EPSG:31467")
// );
proj4.defs(
  "EPSG:31466",
  "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +nadgrids=BETA2007.gsb +units=m +no_defs +type=crs"
);
proj4.defs(
  "EPSG:31468",
  "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +nadgrids=BETA2007.gsb +units=m +no_defs +type=crs"
);

const normalize = (layerwrapper) => {
  if (layerwrapper.isLoading) {
    return "";
  } else
    return `${layerwrapper.layer.url};${
      layerwrapper.layer?.sublayers?.map(({ name }) => name).join(",") || ""
    }`.toLowerCase();
};
const getLeafs = (tree) => {
  if (tree.isLeaf) {
    return [tree];
  } else {
    return tree.children.map((child) => getLeafs(child)).flat(1);
  }
};

const WMSLayerPicker = observer(({ map, view, store, proxy }) => {
  const [url, setUrl] = useState("");
  const [pending, setPending] = useState(false);
  const [tree, setTree] = useState(null);
  const [error, setError] = useState(false);
  const [updateStep, setUpdateStep] = useState(false);
  // const [selection, setSelection] = useState([]);
  // layer erstellen => title rauslesen und dann erst in den Tree => ggf pending / loading als state

  useEffect(() => {
    const onUpdate = () => {
      setUpdateStep(updateStep + 1);
    };
    if (tree) tree.addUpdateListener(onUpdate);

    return () => {
      if (tree) tree.removeUpdateListener(onUpdate);
    };
  }, [tree, updateStep, setUpdateStep]);
  const inStore = store.layers
    .filter((layer) => {
      return (
        !layer.layer.isLoading && layer.layer.url && layer.layer.type === "wms"
      );
    })
    .map((layer) => {
      // TODO ?!?
      return normalize(layer);
    })
    .filter((x) => x !== "");
  const loadingLayers = store.layers
    .filter((x) => x.isLoading && x?.layer?.type === "wms")
    .map((layer) => layer.name)
    .join(",");
  useEffect(() => {
    setUpdateStep(updateStep + 1);
  }, [loadingLayers]);

  const selection = useMemo(() => {
    if (tree) {
      return getLeafs(tree)
        .map((leaf) => {
          if (leaf.data) {
            const str = normalize(leaf.data);
            if (str !== "" && inStore.indexOf(str) !== -1) {
              return getPathToRoot(leaf);
            }
          }
          return "";
        })
        .filter((str) => str !== "");
    } else {
      return [];
    }
    // return getNodesFromIds(tree, selection);
  }, [inStore.join(";;;"), updateStep]);

  useEffect(() => {
    /*  https://developers.arcgis.com/javascript/latest/proxies/
      require(["esri/core/urlUtils"], function(urlUtils) {
        urlUtils.addProxyRule({
          urlPrefix: "my-standalone-arcgis-server.com",
          proxyUrl: "/proxy/Java/proxy.php"
        });
      }); 
      */
    if (proxy) {
      const rule = urlUtils.getProxyRule(url);
      if (url && !rule) {
        urlUtils.addProxyRule({
          urlPrefix: `${url}`.split("?")[0],
          proxyUrl: proxy,
        });
      }
    }
    // console.error("proxy rule", rule, url);
    const effectiveurl = url; //*/ (proxy ? proxy : "") + url;
    let aborted = false;
    if (pending && url) {
      const layer = APIHelperEsri.createWMSLayer(
        { url: effectiveurl, sublayers: [] },
        {}
      ); //
      layer
        .load()
        .then(() => {
          if (!aborted) {
            setTree(
              configToTree(
                {
                  layers: [
                    {
                      url: effectiveurl,
                      name: layer?.resourceInfo?.title || "WMS Layer",
                      type: "wms",
                      info: new TemplateInfo({
                        template:
                          // eslint-disable-next-line no-template-curly-in-string
                          "Name: ${name}\nBeschreibung: ${description}\nCopyright: ${attribution}",
                        recursive: true,
                        isVisible: TemplateInfo.LeafOnlyVisibility,
                      }),
                      topInfo: new TemplateInfo({
                        template:
                          // eslint-disable-next-line no-template-curly-in-string
                          "Name: ${name}\nBeschreibung: ${description}\nCopyright: ${attribution}",
                        isVisible: (layer, node) => {
                          return !(node === null || node === void 0
                            ? void 0
                            : node.loading);
                        },
                        recursive: false,
                      }),
                    },
                  ],
                },
                defaultNLS,
                map,
                view
              )
            );
            setPending(false);
            setError(false);
          }
        })
        .catch((e) => {
          if (!aborted) {
            console.error(e);
            setPending(false);
            setError(true);
          } else {
            console.warn("already aborted: ", e);
          }
        });
    }
    return () => {
      aborted = true;
    };
  }, [url, pending]);
  // console.error("defaultNLS", defaultNLS);
  return (
    <div>
      <TextField
        disabled={pending}
        value={url}
        onChange={(e) => {
          setUrl(e.target.value);
        }}
      />
      <Button
        disabled={pending}
        onClick={() => {
          setPending(true);
        }}
        title={pending ? "Lädt ..." : ""}
      >
        {"Verbinden"}
      </Button>
      {error && (
        <Typography>
          {
            "Es ist ein Fehler beim Laden des Layers aufgetreten. Weitere Informationen sind in der Konsole zu finden."
          }
        </Typography>
      )}
      {!pending && !error && tree && (
        <LayerControlTree
          map={map}
          view={view}
          extTree={tree}
          selected={selection}
          listener={(nodes /*treelayaer*/, nodeIds) => {
            const deselect = selection
              .filter((id) => nodeIds.indexOf(id) === -1)
              .map((id) => getNodeFromId(tree, id))
              .forEach(({ data: layer }) => {
                store.removeLayer(layer);
              });
            console.warn("todeselect", deselect);
            nodes.forEach((node) => {
              if (node.data) {
                const str = normalize(node.data);
                if (inStore.indexOf(str) === -1) {
                  store.addLayer(node.data);
                }
              }
            });
          }}
          nls={defaultNLS}
        />
      )}
    </div>
  );
});

/*
return <WMSLayerPicker
layers={layers.map(({ meta }) => {
  return meta;
})}
onLayersChange={(layers) => {
  setLayers(
    layers.map((layer) => {
      return {
        meta: layer,
        wrapper: createWMSSublayer(
          layer,
          RootStore.mapStore.mapView.map,
          RootStore.mapStore.mapView
        ),
      };
    }) // TODO: eindeutigen Index erstellen => parentlayer + name vom Sublayer => wegenselected
  );
}}
selected={layers
  .map((layer, i) => {
    if (
      store.layers.filter(
        (wrapper) =>
          wrapper.layer.type === "wms" &&
          wrapper.layer.url.toLowerCase() ===
            layer.meta.parentLayerURL.toLowerCase() &&
          wrapper.layer.sublayers
            .map((layer) => layer.name)
            .indexOf(layer.meta.name) !== -1
      ).length > 0
    )
      return i; // parentLayer.url.toLowerCase() + sublayer.name is unique for each layer
    return -1;
  })
  .filter((i) => i !== -1)}
onLayerSelected={(selected) => {
  layers.forEach((layer, i) => {
    const isSelected = selected.indexOf(i) !== -1;
    let storeLayer = null;
    const temp = store.layers.filter(
      (wrapper) =>
        wrapper.layer.type === "wms" &&
        wrapper.layer.url.toLowerCase() ===
          layer.meta.parentLayerURL.toLowerCase() &&
        wrapper.layer.sublayers
          .map((layer) => layer.name)
          .indexOf(layer.meta.name) !== -1
    );
    if (temp.length > 0) storeLayer = temp[0];
    if (storeLayer && !isSelected) {
      store.removeLayer(storeLayer);
    } else if (!storeLayer && isSelected) {
      store.addLayer(layer.wrapper);
    }
  });
}}
/>;
*/

const ExternLayers = ({ children, proxy }) => {
  const [store, setStore] = useState(null);
  const [layers, setLayers] = useState([]);
  useEffect(() => {
    setStore(new StoreGroupLayer({ title: "Externe Layer" }));
  }, []);
  useEffect(() => {
    let handle = null;
    if (store && RootStore.mapStore.mapView) {
      store.addToMap(RootStore.mapStore.mapView.map);
      handle = RootStore.mapStore.mapView.map.layers.on("after-changes", () => {
        const map = RootStore.mapStore.mapView.map;
        const layers = map.layers;
        const storelayer = layers.at(layers.length - 1);
        if (storelayer !== store.groupLayer) {
          APIHelperEsri.putLayerOnTop(map, store.groupLayer);
        }
      });
    }
    return () => {
      if (store && RootStore.mapStore.mapView) {
        store.removeFromMap(RootStore.mapStore.mapView.map);
      }
      if (handle) {
        handle.remove();
      }
    };
  }, [store, RootStore.mapStore.mapView]);
  if (!RootStore.mapStore.mapView || !store)
    return <div>{"Map noch nicht initialisiert"}</div>;

  const WMSPicker = (
    <WMSLayerPicker
      map={RootStore.mapStore.mapView.map}
      view={RootStore.mapStore.mapView}
      store={store}
      proxy={proxy}
      layers={layers.map(({ meta }) => {
        return meta;
      })}
      onLayersChange={(layers) => {
        setLayers(
          layers.map((layer) => {
            return {
              meta: layer,
              wrapper: createWMSSublayer(
                layer,
                RootStore.mapStore.mapView.map,
                RootStore.mapStore.mapView
              ),
            };
          }) // TODO: eindeutigen Index erstellen => parentlayer + name vom Sublayer => wegenselected
        );
      }}
      selected={layers
        .map((layer, i) => {
          if (
            store.layers.filter(
              (wrapper) =>
                wrapper.layer.type === "wms" &&
                wrapper.layer.url.toLowerCase() ===
                  layer.meta.parentLayerURL.toLowerCase() &&
                wrapper.layer.sublayers
                  .map((layer) => layer.name)
                  .indexOf(layer.meta.name) !== -1
            ).length > 0
          )
            return i; // parentLayer.url.toLowerCase() + sublayer.name is unique for each layer
          return -1;
        })
        .filter((i) => i !== -1)}
      onLayerSelected={(selected) => {
        layers.forEach((layer, i) => {
          const isSelected = selected.indexOf(i) !== -1;
          let storeLayer = null;
          const temp = store.layers.filter(
            (wrapper) =>
              wrapper.layer.type === "wms" &&
              wrapper.layer.url.toLowerCase() ===
                layer.meta.parentLayerURL.toLowerCase() &&
              wrapper.layer.sublayers
                .map((layer) => layer.name)
                .indexOf(layer.meta.name) !== -1
          );
          if (temp.length > 0) storeLayer = temp[0];
          if (storeLayer && !isSelected) {
            store.removeLayer(storeLayer);
          } else if (!storeLayer && isSelected) {
            store.addLayer(layer.wrapper);
          }
        });
      }}
    />
  );

  const ShapefileImport = (
    <div>
      <Paper
        variant="outlined"
        color="primary"
        style={{ padding: 5, marginBottom: 10 }}
      >
        {`Notwendig für das Hinzuladen eines Shapefiles ist eine Projektionsdatei und die Verwendung eines der folgenden Projektionssysteme: 
        ETRS32 ( 6-, 7- oder 8-stellige Koordinaten), WGS84. Die entsprechenden Daten müssen als ZIP-Datei vorliegen, um verwendet werden zu können.`}
      </Paper>
      <ShapefileToGeojson
        clearOnAdd={true}
        onChange={(layer, url, geoJSON, symbol) => {
          const wrapper = new Layer(
            layer,
            RootStore.mapStore.mapView.map,
            RootStore.mapStore.mapView
          );
          wrapper.url = "";
          store.addLayer(wrapper);
        }}
      />
    </div>
  );

  const ExternLayersControl = (
    <StoreGroupLayerOverview
      store={store}
      remove={(layer, index) => {
        store.removeLayer(layer);
      }}
      renderLayerSymbolInElement={(symbol, div) => {
        const wrapper = document.createElement("div"); // cause renderPreviewHTML is async
        while (div.children.length > 0) {
          div.removeChild(div.firstChild);
        }
        div.appendChild(wrapper);
        renderPreviewHTML(symbol, { node: wrapper });
      }}
    />
  );

  const hasExternalLayers = Boolean(
    store &&
      store.layers &&
      Array.isArray(store.layers) &&
      store.layers.length > 0
  );

  return (
    <>
      <AccordionPanel
        variant="sub"
        summary={
          <>
            <Typography>{"externe WMS-Dienste"}</Typography>
            <HelpLink
              className="help-link"
              size="20px"
              url="/hauptfunktionen/werkzeugleiste/externe-wms-dienste"
            />
          </>
        }
      >
        {WMSPicker}
      </AccordionPanel>

      <AccordionPanel
        variant="sub"
        summary={
          <>
            <Typography>{"Shapefile Upload"}</Typography>
            <HelpLink
              className="help-link"
              size="20px"
              url="/hauptfunktionen/werkzeugleiste/shapefile-upload"
            />
          </>
        }
      >
        {ShapefileImport}
      </AccordionPanel>

      {hasExternalLayers && (
        <AccordionPanel
          variant="sub"
          summary={
            <>
              <Typography>{"Hinzugefügte Layer:"}</Typography>
              <HelpLink
                className="help-link"
                size="20px"
                url="/hauptfunktionen/werkzeugleiste/hinzugefuegte-layer"
              />
            </>
          }
        >
          {ExternLayersControl}
        </AccordionPanel>
      )}
    </>
  );
};
export default observer(ExternLayers);
